import { render, staticRenderFns } from "./mr_hbf_report.vue?vue&type=template&id=a2b6a24a&scoped=true"
import script from "./mr_hbf_report.vue?vue&type=script&lang=js"
export * from "./mr_hbf_report.vue?vue&type=script&lang=js"
import style0 from "./mr_hbf_report.vue?vue&type=style&index=0&id=a2b6a24a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b6a24a",
  null
  
)

export default component.exports